const initialState = {}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_OCCUPATION':
      return Object.assign({ ...state, occupationId: action.id, occupation: action.data  })
    case 'SET_OTHEROCCUPATION':
      return Object.assign({ ...state, otherOccupation: action.data })
    case 'SET_BUSINESSTYPE':
      return Object.assign({ ...state, businessTypeId: action.id, businessType: action.data })
    case 'SET_OTHERBUSINESSTYPE':
      return Object.assign({ ...state, otherBusinessType: action.data })
    case 'SET_SALARY':
      return Object.assign({ ...state, salaryId: action.id, salary: action.data })
    case 'SET_PROVINCE':
      return Object.assign({ ...state, provinceId: action.id, province: action.data })
    case 'SET_DISTRICT':
      return Object.assign({ ...state, districtId: action.id, district: action.data })
    case 'SET_SUBDISTRICT':
      return Object.assign({ ...state, subDistrictId: action.id, subDistrict: action.data })
    case 'SET_ZIPCODE':
      return Object.assign({ ...state, zipcode: action.data })
    case 'SET_CURRENTADDRESS':
      return Object.assign({ ...state, currentAddress: action.data })
    case 'SET_CURRENTNUMBER':
      return Object.assign({ ...state, currentNumber: action.data })
    case 'SET_CURRENTVILLAGENAME':
      return Object.assign({ ...state, currentVillageName: action.data })
    case 'SET_CURRENTVILLAGE':
      return Object.assign({ ...state, currentVillage: action.data })
    case 'SET_CURRENTFLOOR':
      return Object.assign({ ...state, currentFloor: action.data })
    case 'SET_CURRENTROAD':
      return Object.assign({ ...state, currentRoad: action.data })
    case 'SET_CURRENTPROVINCE':
      return Object.assign({ ...state, currentProvinceId: action.id, currentProvince: action.data })
    case 'SET_CURRENTDISTRICT':
      return Object.assign({ ...state, currentDistrictId: action.id, currentDistrict: action.data })
    case 'SET_CURRENTSUBDISTRICT':
      return Object.assign({ ...state, currentSubDistrictId: action.id, currentSubDistrict: action.data })
    case 'SET_CURRENTZIPCODE':
      return Object.assign({ ...state, currentZipcode: action.data })
    case 'SET_WORKADDRESS':
      return Object.assign({ ...state, workAddress: action.data })
    case 'SET_WORKNUMBER':
      return Object.assign({ ...state, workNumber: action.data })
    case 'SET_WORKVILLAGENAME':
      return Object.assign({ ...state, workVillageName: action.data })
    case 'SET_WORKVILLAGE':
      return Object.assign({ ...state, workVillage: action.data })
    case 'SET_WORKFLOOR':
      return Object.assign({ ...state, workFloor: action.data })
    case 'SET_WORKROAD':
      return Object.assign({ ...state, workRoad: action.data })
    case 'SET_WORKPROVINCE':
      return Object.assign({ ...state, workProvinceId: action.id, workProvince: action.data })
    case 'SET_WORKDISTRICT':
      return Object.assign({ ...state, workDistrictId: action.id, workDistrict: action.data })
    case 'SET_WORKSUBDISTRICT':
      return Object.assign({ ...state, workSubDistrictId: action.id, workSubDistrict: action.data })
    case 'SET_WORKZIPCODE':
      return Object.assign({ ...state, workZipcode: action.data })
    case 'SET_DOCUMENTADDRESS':
      return Object.assign({ ...state, documentAddress: action.data })
    case 'SET_DOCUMENTNUMBER':
      return Object.assign({ ...state, documentNumber: action.data })
    case 'SET_DOCUMENTVILLAGENAME':
      return Object.assign({ ...state, documentVillageName: action.data })
    case 'SET_DOCUMENTVILLAGE':
      return Object.assign({ ...state, documentVillage: action.data })
    case 'SET_DOCUMENTFLOOR':
      return Object.assign({ ...state, documentFloor: action.data })
    case 'SET_DOCUMENTROAD':
      return Object.assign({ ...state, documentRoad: action.data })
    case 'SET_DOCUMENTROVINCE':
      return Object.assign({ ...state, documentProvinceId: action.id, documentProvince: action.data })
    case 'SET_DOCUMENTDISTRICT':
      return Object.assign({ ...state, documentDistrictId: action.id, documentDistrict: action.data })
    case 'SET_DOCUMENTSUBDISTRICT':
      return Object.assign({ ...state, documentSubDistrictId: action.id, documentSubDistrict: action.data })
    case 'SET_DOCUMENTZIPCODE':
      return Object.assign({ ...state, documentZipcode: action.data })
    case 'SET_COUNTRY':
      return Object.assign({ ...state, countryId: action.id, country: action.data })
    case 'SET_INCOME':
      return Object.assign({ ...state, income: action.data })
    case 'SET_OBJECTIVE':
      return Object.assign({ ...state, objective: action.data })
    case 'SET_COMPANYNAME':
      return Object.assign({ ...state, companyName: action.data })
    case 'SET_MARITALSTATUS':
      return Object.assign({ ...state, maritalStatus: action.data })
    case 'SET_CHILDREN':
      return Object.assign({ ...state, childrenId: action.id, children: action.data })
    case 'SET_SPOUSENATIONALITY':
      return Object.assign({ ...state, spouseNationalityId: action.id })
    case 'SET_SPOUSECITIZENID':
      return Object.assign({ ...state, spouseCitizenId: action.data })
    case 'SET_SPOUSELIFELONGCITIZENID':
      return Object.assign({ ...state, spouseLifeLongCitizenId: action.data })
    case 'SET_SPOUSECITIZENIDEXPIREDATE' :
      return Object.assign({ ...state, spouseCitizenIdExpireDate: action.data ,spouseCitizenIdExpireDateText: action.text })
    case 'SET_SPOUSEPASSPORTNO':
      return Object.assign({ ...state, spousePassportNo: action.data })
    case 'SET_SPOUSECOUNTRY':
      return Object.assign({ ...state, spouseCountryId: action.id, spouseCountry: action.data })
    case 'SET_SPOUSEPASSPORTNOEXPIREDATE':
      return Object.assign({ ...state, spousePassportNoExpireDate: action.data ,spousePassportNoExpireDateText: action.text })
    case 'SET_SPOUSETITLE' :
      return Object.assign({ ...state, spouseTitleId: action.id, spouseTitle: action.data })
    case 'SET_OTHERTITLE' :
      return Object.assign({ ...state, otherTitle: action.data })
    case 'SET_SPOUSENAME':
      return Object.assign({ ...state, spouseName: action.data })
    case 'SET_FRISTCHILDRENNATIONALITY':
      return Object.assign({ ...state, fristChildrenNationalityId: action.id })
    case 'SET_FRISTCHILDRENCITIZENID':
      return Object.assign({ ...state, fristChildrenCitizenId: action.data })
    case 'SET_FRISTCHILDRENCITIZENIDEXPIREDATE' :
      return Object.assign({ ...state, fristChildrenCitizenIdExpireDate: action.data ,fristChildrenCitizenIdExpireDateText: action.text })
    case 'SET_FRISTCHILDRENPASSPORTNO':
      return Object.assign({ ...state, fristChildrenPassportNo: action.data })
    case 'SET_FRISTCHILDRENPASSPORTNOEXPIREDATE':
      return Object.assign({ ...state, fristChildrenPassportNoExpireDate: action.data ,fristChildrenPassportNoExpireDateText: action.text })
    case 'SET_FRISTCHILDRENCOUNTRY':
      return Object.assign({ ...state, fristChildrenCountryId: action.id, fristChildrenCountry: action.data })
    case 'SET_FRISTCHILDRENTITLE' :
      return Object.assign({ ...state, fristChildrenTitleId: action.id, fristChildrenTitle: action.data })
    case 'SET_FRISTCHILDRENNAME':
      return Object.assign({ ...state, fristChildrenName: action.data })
    case 'SET_SECONDCHILDRENNATIONALITY':
      return Object.assign({ ...state, secondChildrenNationalityId: action.id })
    case 'SET_SECONDCHILDRENCITIZENID':
      return Object.assign({ ...state, secondChildrenCitizenId: action.data })
    case 'SET_SECONDCHILDRENCITIZENIDEXPIREDATE' :
      return Object.assign({ ...state, secondChildrenCitizenIdExpireDate: action.data ,secondChildrenCitizenIdExpireDateText: action.text })
    case 'SET_SECONDCHILDRENPASSPORTNO':
      return Object.assign({ ...state, secondChildrenPassportNo: action.data })
    case 'SET_SECONDCHILDRENCOUNTRY':
      return Object.assign({ ...state, secondChildrenCountryId: action.id, secondChildrenCountry: action.data })
    case 'SET_SECONDCHILDRENPASSPORTNOEXPIREDATE':
      return Object.assign({ ...state, secondChildrenPassportNoExpireDate: action.data ,secondChildrenPassportNoExpireDateText: action.text })
    case 'SET_SECONDCHILDRENTITLE' :
      return Object.assign({ ...state, secondChildrenTitleId: action.id, secondChildrenTitle: action.data })
    case 'SET_SECONDCHILDRENNAME':
      return Object.assign({ ...state, secondChildrenName: action.data })
    case 'SET_SUITABILITYTESTSCORE':
      return Object.assign({ ...state, suitabilityTestScore: action.data })
    case 'SET_IDCARDPICTURE':
      return Object.assign({ ...state, idCardPicture: action.data })
    case 'SET_BANK' :
      return Object.assign({ ...state, bankId: action.id, bank: action.data })
    case 'SET_BANKACCOUNTNUMBER' :
      return Object.assign({ ...state, bankAccountNumber: action.data })
    case 'SET_BOOKBANKPICTURE':
      return Object.assign({ ...state, bookBankPicture: action.data })
    case 'SET_SIGNATUREPICTURE':
      return Object.assign({ ...state, signaturePicture: action.data })
    default:
      return state
  }
}
